export const addLinkAriaLabels = ({
  linkText,
  openInNewTab = "opens in a new tab",
  html = "",
}: {
  linkText?: string | undefined;
  openInNewTab?: string;
  html?: string;
} = {}): string =>
  html.replaceAll(
    /<a\b([^>]*\btype=(?:"external"|'external'|"internal"|'internal')[^>]*)>([\s\S]*?)<\/a>/gi,
    (match, originalAttributes, linkInnerText) => {
      if (
        typeof originalAttributes === "string" &&
        typeof linkInnerText === "string"
      ) {
        if (/\baria-label\s*=\s*['"]/i.test(originalAttributes)) {
          return match;
        }

        // eslint-disable-next-line sonarjs/super-linear-regex -- stretch goal
        const text = linkInnerText.replaceAll(/<[^>]+>/g, "").trim();
        if (!text) {
          return match;
        }

        const isExternal = /\btype\s*=\s*['"]external['"]/i.test(
          originalAttributes,
        );
        const resolvedLinkText =
          linkText ?? (isExternal ? "external link" : "internal link");

        const hasTargetBlank = /\btarget\s*=\s*['_"]_blank['_"]/i.test(
          originalAttributes,
        );

        const description = hasTargetBlank
          ? `${resolvedLinkText}, ${openInNewTab}`
          : resolvedLinkText;

        const aria = `${text} (${description})`;
        const safeAria = aria.replaceAll('"', "&quot;");

        const newAttributePart = `${originalAttributes} aria-label="${safeAria}"`;
        return `<a${newAttributePart}>${linkInnerText}</a>`;
      }

      return html;
    },
  );
